import { ColDef } from "ag-grid-community"
import TargetDateRenderer from "pages/shared/target-date-renderer/TargetDateRenderer";
import EventTypeRenderer from "pages/shared/event-type-renderer/EventTypeRenderer";
import AvailableSlotsRenderer from "pages/shared/available-slots-renderer/AvailableSlotsRenderer";
import ContactCompanyRenderer from "pages/shared/contact-company-renderer/ContactCompanyRenderer";
import BudgetRenderer from "pages/shared/budget-renderer/BudgetRenderer";
import { PublicLead } from "./topchef.types";
import StatusRenderer from "pages/shared/status-renderer/StatusRenderer";
import { TFunction } from 'i18next';

const DateTimeCellRenderer = (params: any) => {
    return (
      <TargetDateRenderer {...params.data}/>
    );
};

const EventTypeCellRenderer = (params: any) => {
  return (
    <EventTypeRenderer eventValue={params.value}/>
  );
};

const SourceCellRenderer = (params: any) => {
  return (
    <ContactCompanyRenderer contactCompany={params.value}/>
  );
};

const AvailableSlotsCellRenderer = (params: any) => {
  return (
    <AvailableSlotsRenderer lead={params.data} maxSlots={4}/>
  );
};


const BudgetCellRenderer = (params: any) => {
  return (
    <BudgetRenderer amount={params.value}/>
  );
};

const StatusCellRenderer = (params: any) => {
  return (
    <StatusRenderer status={params.value} />
  );
};

export interface PublicLeadDefinitionProps {
    detailsRenderer: any,
    t: TFunction,
}

export const getPublicLeadColumnDefinition = (params: PublicLeadDefinitionProps): ColDef<PublicLead>[] => [
    { field: "source", headerName: params.t('grid.headers.source') as string, wrapText:true, minWidth: 120, cellRenderer: SourceCellRenderer },
    { field: "contactCompany", headerName: params.t('grid.headers.contactCompany') as string, minWidth: 120},
    { field: "type", headerName: params.t('grid.headers.type') as string, minWidth: 120, cellRenderer: EventTypeCellRenderer},
    { field: "targetDate", headerName: params.t('grid.headers.targetDate') as string, minWidth: 80, maxWidth: 100, cellRenderer: DateTimeCellRenderer },
    { field: "guests", headerName: params.t('grid.headers.guests') as string, maxWidth: 70 },
    { field: "budget", headerName: params.t('grid.headers.budget') as string, maxWidth: 95, cellRenderer: BudgetCellRenderer },
    { field: "city", headerName: params.t('grid.headers.city') as string },
    { field: "availableSlots", headerName: params.t('grid.headers.availableSlots') as string, minWidth: 100, maxWidth: 120, cellRenderer: AvailableSlotsCellRenderer },
    { field: "status", headerName: params.t('grid.headers.status') as string, minWidth: 100, cellRenderer: StatusCellRenderer },
    { field: "id", headerName: params.t('grid.headers.details') as string, minWidth: 80, maxWidth: 100, cellRenderer: params.detailsRenderer },
];